<style>
.vue-daterange-picker .ranges {
  float: right;
  border-left: 1px solid #ddd;
}
.daterangepicker {
  border-left: none !important;
}
@media (max-width: 1440px) {
  .statistic {
    padding: 0 !important
  }
}
.reportrange-text{
  border-radius: 10px;
  height: 37px;
  line-height: 27px;
}
.title{
  font-size: 2.2rem;
  font-weight: bold;
  opacity: 0.7;
}
</style>
<template>
  <div style="margin:0px 10px 0px 10px">
    <div class="vx-row warning" >
      <div class="vx-col md:w-1/6 w-full my-4">
        <h3 class="mt-1 title">{{$t('warningManager.warning')}}</h3>
      </div>
      <div class="vx-col md:w-1/3 w-full mt-4 " >
        <vs-input class="w-full" v-model="content" :placeholder="$t('warningManager.searchWarningContent')" @keypress.enter="searchContent"></vs-input>

      </div>
      <div class="ml-0 mt-6 ml-4 mb-2" style="min-width:200px">
        <span class="text-size"> <b>{{$t('warningManager.status')}}</b> </span>
        <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer" >
          <span v-if="valueAll"><b style="color:#277DF6" class="text-size">{{valueAll}}</b></span>
          <span v-if="valueSeen"><b style="color:#277DF6" class="text-size">{{valueSeen}}</b></span>
          <span v-if="valueNotSeen"><b style="color:#277DF6">{{valueNotSeen}}</b></span>
          <feather-icon icon ="ChevronDownIcon" style="vertical-align:middle;width:1rem" class=" color-text"> </feather-icon>
          <vs-dropdown-menu class="vx-navbar-dropdown" style="width:160px" :open="'left'" >
            <vs-dropdown-item >
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" @click="clickNewPost" style="color: #626262">
                <span class="ml-2" style="vertical-align:middle">{{$t('warningManager.statusAll')}}</span>
              </li>
            </vs-dropdown-item>
            <vs-dropdown-item >
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" @click="seenPost" style="color: #626262">
                <span class="ml-2" style="vertical-align:middle">{{$t('warningManager.statusRead')}}</span>
              </li>
            </vs-dropdown-item>
            <vs-dropdown-item >
              <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white color-text" @click="notSeen" style="color: #626262">
                <span class="ml-2" style="vertical-align:middle">{{$t('warningManager.statusUnread')}}</span>
              </li>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>
      <div class="mt-4 ml-2 mb-2" style = "text-align: right;">
        <span class="text-size"><b>{{$t('title.time')}}</b> </span>
        <date-range-picker
          ref="picker"
          :locale-data="{format: 'dd/mm/yyyy' }"
          :opens="'left'"
          @update="filterDate"
          v-model="dateRange"
          class="boder-date-ranpicker ml-2"
        >
        </date-range-picker>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col md:w-3/12 w-full pl-0">
        <div class="warning vx-col  w-full p-2">
          <div class="vx-col w-full border-bottom">
            <span><b>{{$t('warningManager.category')}}</b></span>
          </div>

          <!-- <div class="vx-col w-full mt-2">
            <vs-button style="width:100%;padding-left: 15px;align-content: center"
                       color ="primary"
                       type ="border"
                       icon-pack ="feather"
                       icon ="icon-settings"
                       @click="warningSetting"
            >
              {{$t('button.warningManagement')}}
            </vs-button>
          </div>

          <div class="vx-col w-full mt-2">
            <vs-button style="width:100%;padding-left: 15px"
                       color ="primary"
                       type ="border"
                       icon-pack ="feather"
                       icon ="icon-plus"
                       @click="createWarningSetting"
            >
              {{$t('button.newWarning')}}
            </vs-button>
          </div>

          <div class="vx-col w-full mt-2">
            <vs-button style="width:100%;padding-left: 15px"
                       color ="primary"
                       type ="border"
                       icon-pack ="feather"
                       icon ="icon-flag"
                       @click="followingArticle"
            >
              {{$t('button.trackingToSpecialNews')}}

            </vs-button>
          </div> -->
          <div class="vx-col w-full mt-2">
            <vs-button style="width:100%;padding-left: 15px;z-index:1"
                       color ="primary"
                       type ="border"
                       icon-pack ="feather"
                       icon ="icon-bell"
                       @click="openPopup"
            >
              {{$t('button.manageNotificationsAccount')}}
            </vs-button>
          </div>
          <div class="vx-col w-full mt-2" >
            <vs-button style="width:100%;padding-left: 15px;z-index:1"
                       color ="primary"
                       type ="border"
                       icon-pack ="feather"
                       icon ="icon-activity"
                       @click="classificationSetting"
            >
              {{$t('button.shadeRules')}}
            </vs-button>
          </div>

          <div class="vx-col w-full mt-2" >
            <vs-button style="width:100%;padding-left: 15px;z-index:1"
                       color ="primary"
                       type ="border"
                       icon-pack ="feather"
                       icon ="icon-alert-circle"
                       @click="settingNegative"
            >
              {{$t('button.threshold')}}
            </vs-button>
          </div>

          <div class="vx-col w-full mt-2" >
            <vs-button style="width:100%;padding-left: 15px;z-index:1"
                       color ="primary"
                       type ="border"
                       icon-pack ="feather"
                       icon ="icon-delete"
                       @click="deleteAll"
            >
              {{$t('button.deleteAll')}}
            </vs-button>
          </div>
        </div>
      </div>


      <div class="warning vx-col md:w-4/12 w-full" style="max-height: 540.79px" >
        <div class="vx-col  w-full">
          <div class="vx-col mt-2 w-full border-bottom ">
            <span><b>{{$t('warningManager.allWarning')}}</b></span>
            <span><b>({{dataRowList.length}})</b></span>
          </div>
          <VuePerfectScrollbar ref="scrollDialog" class="scroll-area--nofications-dropdown p-0 mb-4"
                               id="scrollId" @ps-y-reach-end="nextPage"
                               :settings="settings" style="max-height: 36rem">
            <div :class="'vx-row cursor-pointer mb-2 m-1 item-height color_' + index" v-for="(item,index) in dataRowList" :key="index" :style="item.style" @click="getContent(item, index)">
              <div class="vx-col md:w-1/6 w-full mt-2">
                <img :src="item.domainImage" style="height: 5rem;margin-right:5px;width:5rem;object-fit: contain;object-position: center;">
              </div>
              <div class="vx-col md:w-5/6 mt-2 w-full">
                    <span class="title-line my-4 mx-6">
                      <b>{{item.details.fullContents.filter(item => item.type == "text")[0].content}}</b></span>
                <div style="text-align:right">
                  <span>{{elapsedTime (item.createdDate)}} </span>
                </div>
              </div>
            </div>

          </VuePerfectScrollbar>
        </div>
      </div>

      <div class="vx-col md:w-5/12 w-full pr-0">
        <div class="warning vx-col  w-full p-4 card-height " style="max-height: 540.79px;overflow: hidden">
          <div class=" vx-col w-full mb-2 border-bottom" style="margin-top: -6.5px;">
            <span class="ml-2"><b>{{$t('warningManager.contentWarning')}}</b></span>
          </div>
          <VuePerfectScrollbar
            ref="scrollDialog" class="scroll-area--nofications-dropdown p-0"
            :settings="settings" style="max-height: 31rem" >
            <div class="vx-row" v-if="formDetail == true">
              <div class="vx-col w-full mt-2 pl-2" style="margin-left:10px">
                <div class="vx-row">
                  <div class="vx-col w-full mt-2 title-line ml-4" style="text-align:center;height:20rem" v-if="selectedContent">
                    <img :src="form.domainImage" style="width:30rem;height:20rem;object-fit: contain;object-position: center;">
                  </div>
                  <div class="vx-col w-full mt-2 ml-4">
                    <span><b>{{form.title}}</b></span>
                  </div>
                </div>
                <div class="vx-row">

                  <div class="w-full pr-8 pl-4" style="text-align: justify">
                    <h6 data-v-3e4a5c2c="" class="item-name font-semibold mb-1 cursor-pointer" v-html = "this.form.description"></h6>
                    <p v-if = "this.form.author" data-v-3e4a5c2c="" class="text-sm mb-4">
                      <span data-v-3e4a5c2c="" class="font-semibold cursor-pointer">{{this.form.displayPublishDate}}</span>
                    </p>
                    <p data-v-3e4a5c2c="" class="item-description text-sm ml-4" v-html = "this.form.displayFullContent"></p>
                    <p v-if = "this.form.author" data-v-3e4a5c2c="" class="text-sm mb-4 mt-3">Tác giả:
                      <span data-v-3e4a5c2c="" class="font-semibold cursor-pointer">{{this.form.author}}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </VuePerfectScrollbar>
          <div class=" vx-col w-full mt-2 modal-footer footer-warningContent" style="heigh:10%" v-if="selectedContent">
            <a class="text-size" :href="this.form.url" target="_blank">
            <div class="link-content cursor-pointer actives mt-2 mr-2" style="float: right" >
                <feather-icon icon="Link2Icon" style="vertical-align: bottom;width:15px"></feather-icon>
                {{$t('button.originalPost')}}
            </div>
            </a>
            <div class="copy-link cursor-pointer actives mt-2 mr-2" :data-url = this.form.url @click="copyLink" style="float: right">
              <a id="link">
                <feather-icon  icon ="CopyIcon" style="vertical-align: bottom;width:15px"></feather-icon>
                {{$t('button.copyLink')}}
              </a>
            </div>
          </div>


        </div>
      </div>

    </div>
    <vs-popup :title="$t('warningManager.emailGetNotify')" :active.sync="activePopup">
      <div class="vx-row">
        <div class="vx-col w-full"  v-for="(item) in tagsListAction " >
          <div class="vx-col col-12 w-full mt-1">
            <vue-tags-input style = "margin-top: 0px !important;max-width: 100% !important;"
                            v-validate="'max:255'"
                            :placeholder="$t('warningManager.importEmail')"
                            v-model="item.tag2"
                            :tags=item.action
                            @tags-changed="newTags => item.action = newTags"
                            @before-adding-tag="checkTag"
                            allow-edit-tags
            />
          </div>
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
                <vs-button class="border-radius ml-auto mt-2" icon="icon-X" icon-pack="feather" @click="sendRequest" :disabled="!validateForm">{{$t('managerKeyword.acceptText')}}
                </vs-button>
                <vs-button class="border-radius ml-4 mt-2" type="border" icon="icon-X" icon-pack="feather" @click="closePopup">{{$t('button.closed')}}
                </vs-button>
              </div>
            </div>
          </div>
          <template >
            <vs-table  pagination max-items="8" search :data="users" strip :noDataText="$t('noData')">
              <template slot="header">
                <h3>{{$t('warningManager.list')}}</h3>
              </template>
              <template slot="thead">
                <vs-th sort-key="email">
                  Email
                </vs-th>
                <vs-th style="justify-content: center;display: flex;" >
                  {{$t('warningManager.action')}}
                </vs-th>
              </template>
              <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
                  <vs-td :data="data[indextr].email">
                    {{data[indextr].email}}
                  </vs-td>
                  <vs-td style="justify-content: center;display: flex;">
                    <feather-icon style="justify-content: center" icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="confirmDeleteRecord(indextr)"/>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </template>
        </div>
      </div>
    </vs-popup>

    <vs-popup :title="this.$t('warningManager.titlePercent')" :active.sync = "activeSettingNegative">
      <div class="vx-row">
        <div class="vx-col mt-2 w-full">
          <vs-slider
            v-model="valueSetting"
            :min="0"
            :max="10"
            :interval="1"
            :adsorb="true"
          />
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 mb-4 flex flex-wrap items-center justify-end">
            <vs-button class="border-radius ml-auto mt-2" icon="icon-X" icon-pack="feather" @click="updateThreshold" :disabled="!validateForm">{{$t('managerKeyword.acceptText')}}
            </vs-button>
            <vs-button class="border-radius ml-4 mt-2" type="border" icon="icon-X" icon-pack="feather" @click="activeSettingNegative = false">{{$t('button.closed')}}
            </vs-button>
          </div>
        </div>
      </div>
    </vs-popup>
  </div>
</template>
<script>

import NoImage from '@/assets/images/logo/no_image.png';
import DateRangePicker from "../../../../layouts/components/vue2-daterange-picker/components/DateRangePicker";
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import VueSimpleSuggest from 'vue-simple-suggest'
import 'vue-simple-suggest/dist/styles.css'
import {AgGridVue} from "ag-grid-vue"
import VueTagsInput from '@johmun/vue-tags-input';
import VueSlider from 'vue-slider-component'

export default {
  components:{
    DateRangePicker,
    VuePerfectScrollbar,
    VueSimpleSuggest,
    AgGridVue,
    VueTagsInput,
    VueSlider

  },
  computed:{
    validateForm() {
      return !this.errors.any();
    }
  },
  watch:{
    '$store.state.isUpdateUser'(val) {
      if (val) {
        this.initScreen();
        this.$store.commit('UPDATE_USER_SUCCESS', false);
      }
    },
    validateEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
  },
  data(){
    return {
      indexEmail: null,
      valueSetting: 0,
      activeSettingNegative:false,
      checkEmail: false,
      users:[],
      simpleSuggestionList:[],
      selectedContent:false,
      valueAll : null,
      valueSeen : null,
      valueNotSeen : null,
      fromDate: null,
      toDate: null,
      dateRangePicker: function(){
        this.dateRange.startDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
        this.dateRange.endDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
        this.from = this.dateRange.startDate;
        this.to = this.dateRange.endDate
      },
      settings: {
        wheelSpeed: .30,
        suppressScrollX: true,
      },
      dateRange: {
        endDate: new Date(),
        startDate: (() => { let date = new Date ();
          date.setDate(date.getDate() - 6);
          date.setHours(0,0,0);
          return date
        })()
      },
      loadDataNofity:null,
      content:"",
      dataRow:[],
      dataRowList:[],
      dataRowPage:[],
      dataRowStatus:[],
      totalWarning:null,
      unreadNotifications:null,
      form:{
        name:null,
        content:null,
        displayFullContent:null,
        domainImage:null,
        title:null,
        noImage:null,
        id:null,
        url:null
      },
      formDetail:false,
      radio:'FrownIcon',
      rangeDate :null,
      link:'https://facebook.com',
      copied: '',
      bookmark:true,
      star:false,
      activePopup: false,
      tagsListAction:[{
        action:[]
      }],
      page:0
    }
  },
  async created(){
    this.dateRange.startDate = new Date(
      this.dateRange.startDate.setHours(0, 0, 0)
    );
    this.dateRange.endDate = new Date(
      this.dateRange.endDate.setHours(23, 59, 59)
    );
    this.initScreen();
    this.$eventBus.$on('i18n', () =>{
      this.initScreen()
    })
    if(this.$messaging && this.$messaging.onMessage){
      this.$messaging.onMessage((payload) => {
      let color = "success;"
      if (payload.data.type == "warning") {
        color = "danger"
      }
      this.selectedNtf = payload;
      this.initScreen()
      return this.$vs.notify({
        text: payload.notification.title,
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: color,
        click: this.openUrlInPopup

      });
    });
    }

  },
  methods: {
    closePopup(){
      document.getElementsByClassName('input-search vs-table--search-input')[0].value=""
      this.activePopup=false;
    },
    updateThreshold: function(){
        let info = localStorage.getItem("userInfo");
        let userInfo = JSON.parse(info);
        const payload = {
          id: userInfo.id,
          threshold : this.valueSetting/10
        }
        this.$vs.loading();
        this.$oauth.post('/user/thres-hold', payload).then(() => {
          this.$vs.loading.close();
          this.activeSettingNegative = false;
          this.$vs.notify({
            text: this.$t('warningManager.textNotifi'),
            icon: 'feather',
            iconPack: 'icon-alert',
            color: 'primary'
          })
        })
    },
    settingNegative: function(){
      let info = localStorage.getItem("userInfo");
      let userInfo = JSON.parse(info);
      const payload = {
        id: userInfo.id,
      }
      this.$vs.loading();
      this.$oauth.post('/user/find-by-id-setting', payload).then((res) => {
        this.valueSetting = res.data.threshold*10;
        this.activeSettingNegative = true;
        this.$vs.loading.close();
      })
    },
    nextPage(){
      if (this.dataRowList.length >= this.totalWarning || content.length > 0) return false;
      if(this.dataRow.length>0){
        this.page += 1;
        const payload ={
          pageNumber:parseInt(this.page),
          pageSize:10,
        };
        this.$vs.loading();
        this.$processor.post('/warning-message/get-all',payload).then((res) =>{
          this.dataRowPage=[];
          this.dataRowPage = res.data.content;
           this.$vs.loading.close();
          this.dataRowPage.forEach(el =>{
            let details = JSON.parse(el.body)
            el.details = details;
            if(el.details && el.details.attachmentUrls.length > 0){
              el.domainImage = el.details.attachmentUrls[0].url;
            }else{
              el.domainImage = NoImage;
            }
            el.name = el.title;
            // el.author = el.details.specialFields ? el.details.specialFields.author ? el.details.specialFields.author : "" : ""
            el.date = el.createDate;
            let dateNow = new Date().getDate();
            let createdDate =  new Date(el.createdDate).getDate();
            this.rangeDate = dateNow - createdDate;
          });
          this.unreadNotifications = res.data.content.map(item =>{
            item.style ={
              'background-color' : item.seenStatus == 0 ? '#edf2fa' : '#fff'
            }
            return item;
          })
          if(this.dataRowPage && this.form.id){
            this.dataRowPage.filter(item =>  item.id == this.form.id).map(value => {
              if(value.details && value.details.fullContents.length > 0){
                this.form.displayFullContent = value.details.fullContents.filter(item => item.type == "text").map((item) => {
                  if(item.content){
                    return item.content.trim();
                  }
                }).join("\n");
              }
              if(value.details && value.details.attachmentUrls.length > 0){
                this.form.domainImage = value.details.attachmentUrls[0].url;
              }
              if(value.title){
                this.form.title = value.title;
              }
              if(value.details && value.details.attachmentUrls.length  < 1){
                this.form.domainImage  =  NoImage;
              }
              if(value.details.url){
                this.form.url = value.details.url;
              }
            });
            this.formDetail = true;
          }
          this.dataRowList.push(...this.dataRowPage)
          this.resultData.push(...this.dataRowPage)
        }).catch(()=>{
          this.$vs.loading.close();
        })
      }
    },
    showDeleteSuccess() {
      this.$store.commit('UPDATE_USER_SUCCESS', true);
      this.$vs.notify({
        color: 'primary',
        text: this.$t('warningManager.textDelete'),
        iconPack: 'feather',
        icon: 'icon-alert-circle',
      })
    },
    confirmDeleteRecord(item) {
      this.indexEmail = item;
      this.$vs.dialog({
        class:'vdialognew',
        type: 'confirm',
        color: 'danger',
        title: this.$t('warningManager.titleDelete'),
        text: `${this.$t('warningManager.textDelete')}` + ` "${this.users[item].email}" `,
        accept: this.deleteRecord,
        acceptText: this.$t('warningManager.acceptText'),
        cancelText: this.$t('warningManager.cancelText')
      })
    },
    validateEmail: function(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    deleteRecord() {
      const payload = {
        emailAllowNotify: this.users[this.indexEmail].email
      }
      this.$vs.loading();
      this.$oauth.post(`/user/remove-email`, payload).then(() => {
        this.$vs.loading.close();
        this.initScreen();
        return this.showDeleteSuccess();
      }).catch((err) => {
        this.$vs.loading.close();
        return this.$vs.notify({
          text: err.response.data.message || err.response.data.error_description || err.response.data.error,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        });
      });
    },
    onChangePage: function(){
      this.$oauth.post('/user/user-allow').then((res) => {
        let result= res.data[0];
        let data = [];
        if(result && result.emailAllowNotify && result.emailAllowNotify.length > 0){
            data = result.emailAllowNotify.split(',');
            this.users = data.map(el => {
              return {
                email: el
              }
            });
        }
        else {
          this.users = []
        }
      })
    },
    sendRequest: function(){
      let checkValidateEmail = false;
      const result = this.tagsListAction[0].action.map(el =>  el.text);
      if (result.length < 1){
        return this.$vs.notify({
          text:this.$t('warningManager.textEmailEmpty'),
          icon:'icon-alert',
          iconPack:'feather',
          color:'danger'
        })
      }
      else{
        result.forEach(el => {
          if (!this.validateEmail(el)){
            checkValidateEmail = true;
            return this.$vs.notify({
              text:this.$t('warningManager.textEmailInvalidate') + ':' + el,
              icon:'icon-alert',
              iconPack:'feather',
              color:'danger'
            })
          }
        })
      }
      if (checkValidateEmail) return false;
      const data = this.users;
      let checkEmail = false;
      result.map(email => {
        data.map(el => {
          if(email.toLowerCase() == el.email.toLowerCase()){
            checkEmail =  true
          }
        })
      })
      if(checkEmail){
        return this.$vs.notify({
          text: this.$t('warningManager.textEmailWasRegistered'),
          icon: 'icon-alert',
          iconPack: 'feather',
          color: 'danger'
        })
      }
      this.$vs.loading();
      const payloadUser = {
        emailAllowNotify: result.toString()
      }
      this.$oauth.post('/user/update-notify', payloadUser).then(() => {
        this.tagsListAction[0].action = [];
        this.initScreen();
        this.$vs.loading.close();
        return this.$vs.notify({
          text: this.$t('warningManager.textSuccessfulNotification'),
          icon: 'icon-alert',
          iconPack: 'feather',
        })
      })
    },
    checkTag(obj) {
      obj.addTag();
    },
    openPopup: function(){
      this.activePopup = true;
      setTimeout(()=>{
        let element= document.getElementsByClassName('input-search vs-table--search-input')[0];
        element.value=""
        element.dispatchEvent(new Event("input"));
      })

      this.tagsListAction[0].tag2 = [];
      this.tagsListAction[0].action = [];
    },
    classificationSetting: function(){
      this.$router.push('/user/classify');
    },
    getListTopic:function(){
      const payload ={
      };
      return new Promise((resolve, reject) => {
        this.$business.post('/topic/find-by-conditions',payload).then((response) =>{
          this.$business.post(`share-topic/get-all-share`,  payload).then((res) =>{
            const topicShare = res.data.filter(el => el.status == 1);
            this.optionalsTopic = [...response.data,...topicShare];
            this.userTopics = [...response.data,...topicShare];
            const inputSuggest = this.optionalsTopic;
            this.simpleSuggestionList = inputSuggest;
            if(this.optionalsTopic.length > 0){
              this.optionalsTopic = this.optionalsTopic.map(el =>{
                return {
                  label:el.topicName,
                  value:el.id
                }
              })
              if (this.topicId) {
                let selectedItem = this.optionalsTopic.find(item => item.value == this.topicId)
                if (selectedItem) this.topicSelected = selectedItem;
              }
              this.optionalsTopic.unshift({label: "Tất cả",
                value: null})
            }
            resolve()
          })
        })
          .catch(() =>{reject()})
      })

    },
    filterDate : function (){
      let fromDate = new Date(this.dateRange.startDate.setHours(0, 0, 0));
      let toDate = new Date(this.dateRange.endDate.setHours(23, 59, 59));
      let result  =  this.resultData
      result = result.filter(function (el){
        let createdDate = new Date( el.createdDate);
        return createdDate >=fromDate && createdDate <= toDate;
      })
      this.dataRowList = result ;
    },
    clickNewPost: function (){
      this.dataRowList = this.resultData;
      this.valueAll = this.$t('warningManager.statusAll')
      this.valueSeen = ''
      this.valueNotSeen = ''
    },
    seenPost : function (){
      this.dataRowList = this.resultData;
      this.valueSeen = this.$t('warningManager.statusRead')
      this.valueAll = ''
      this.valueNotSeen = ''
      this.dataRowList = this.dataRowList.filter(el => el.seenStatus == 1);
    },
    notSeen : function (){
      this.dataRowList = this.resultData;
      this.valueNotSeen = this.$t('warningManager.statusUnread')
      this.valueSeen = ''
      this.valueAll = ''
      this.dataRowList = this.dataRowList.filter(el => el.seenStatus == 0);
    },
    initScreen: function(){
      this.onChangePage();
      this.nextPage();
      this.getListFacebookWarning();
      this.getLists();
      let id = this.$route.query.id;
      if(id){
        this.$processor.post('/warning-message/seen/' + id).then((res) => {
          this.getContent(res.data, null);
        })
      }
      this.valueAll = this.$t('warningManager.statusAll')
      this.$vs.loading.close();
    },
    imgError(image){
      image.target.src = NoImage;
    },
    elapsedTime(startTime) {
      let x        = new Date(startTime)
      let now      = new Date()
      var timeDiff = now - x
      timeDiff    /= 1000

      var seconds = Math.round(timeDiff)
      timeDiff    = Math.floor(timeDiff / 60)

      var minutes = Math.round(timeDiff % 60)
      timeDiff    = Math.floor(timeDiff / 60)

      var hours   = Math.round(timeDiff % 24)
      timeDiff    = Math.floor(timeDiff / 24)

      var days    = Math.round(timeDiff % 365)
      timeDiff    = Math.floor(timeDiff / 365)

      var years   = timeDiff
      if (years > 0) {
        return years + ' năm trước'
      } else if (days > 0) {
        return days + ' ngày trước'
      } else if (hours > 0) {
        return hours + ' giờ trước'
      } else if (minutes > 0) {
        return minutes + ' phút trước'
      } else if (seconds > 0) {
        return (seconds > 1 ? seconds + ' giây trước' : ' Vừa xong')
      }

      return 'Vừa xong'
    },
    searchContent: function(){
      this.dataRowList = this.resultData;
      let dataFilter = [];
      let content = this.content.toLowerCase();
      this.dataRowList.forEach(el => {
        let contentData = JSON.parse(el.body).content;
        let indexKey = contentData.toLowerCase().indexOf(content);
        if (indexKey >= 0){
          dataFilter.push(el);
        }
      })
      this.dataRowList = dataFilter;
    },
    getLists:function (){
      const payload ={
        pageNumber:0,
        pageSize:5,
      };
      this.$processor.post('/warning-message/list',payload)
        .then((res)=>{
          this.dataRow = res.data;
          this.dataRowStatus = res.data;
          this.totalWarning=res.data.length;
          this.length = res.data.length;
          this.dataRowStatus.forEach(el =>{
            let details = JSON.parse(el.body)
            el.details = details;
            if(el.details && el.details.attachmentUrls.length > 0){
              el.domainImage = el.details.attachmentUrls[0].url;
            }else{
              el.domainImage = NoImage;
            }
            el.name = el.title;
            // el.author = el.details.specialFields ? el.details.specialFields.author ? el.details.specialFields.author : "" : ""
            el.date = el.createDate;
            let dateNow = new Date().getDate();
            let createdDate =  new Date(el.createdDate).getDate();
            this.rangeDate = dateNow - createdDate;
          });
          if(this.dataRowStatus && this.form.id){
            this.dataRowStatus.filter(item =>  item.id == this.form.id).map(value => {
              if(value.details && value.details.fullContents.length > 0){
                this.form.displayFullContent = value.details.fullContents.filter(item => item.type == "text").map((item) => {
                  if(item.content){
                    return item.content.trim();
                  }
                }).join("\n");
              }
              if(value.details && value.details.attachmentUrls.length > 0){
                this.form.domainImage = value.details.attachmentUrls[0].url;
              }
              if(value.title){
                this.form.title = value.title;
              }
              if(value.details && value.details.attachmentUrls.length  < 1){
                this.form.domainImage  =  NoImage;
              }
              if(value.details.url){
                this.form.url = value.details.url;
              }
            });
            this.formDetail = true;
          }})
    },
    getListFacebookWarning: function(){
      const payload ={
        pageNumber:0,
        pageSize:10,
      };
      this.$processor.post('/warning-message/get-all',payload).then((res) =>{
        this.dataRowList=res.data.content;
        this.resultData=res.data.content;
        this.dataRowList.forEach(el =>{
          let details = JSON.parse(el.body)
          el.details = details;
          if(el.details && el.details.attachmentUrls.length > 0){
            el.domainImage = el.details.attachmentUrls[0].url;
          }else{
            el.domainImage = NoImage;
          }
          el.name = el.title;
          // el.author = el.details.specialFields ? el.details.specialFields.author ? el.details.specialFields.author : "" : ""
          el.date = el.createDate;
          let dateNow = new Date().getDate();
          let createdDate =  new Date(el.createdDate).getDate();
          this.rangeDate = dateNow - createdDate;
        });
        this.unreadNotifications = res.data.content.map(item =>{
          item.style ={
            'background-color' : item.seenStatus == 0 ? '#edf2fa' : '#fff'
          }
          return item;
        })
        if(this.dataRowList && this.form.id){
          this.dataRowList.filter(item =>  item.id == this.form.id).map(value => {
            if(value.details && value.details.fullContents.length > 0){
              this.form.displayFullContent = value.details.fullContents.filter(item => item.type == "text").map((item) => {
                if(item.content){
                  return item.content.trim();
                }
              }).join("\n");
            }
            if(value.details && value.details.attachmentUrls.length > 0){
              this.form.domainImage = value.details.attachmentUrls[0].url;
            }
            if(value.title){
              this.form.title = value.title;
            }
            if(value.details && value.details.attachmentUrls.length  < 1){
              this.form.domainImage  =  NoImage;
            }
            if(value.details.url){
              this.form.url = value.details.url;
            }
          });
          this.formDetail = true;
        }
        this.$vs.loading.close();
      }).catch(()=>{
        this.$vs.loading.close();
      })
    },
    getContent: function(value, index){
      if (index==0||index) {
        document.getElementsByClassName("color_" + index)[0].style.backgroundColor = '#fff';
      }
      this.selectedContent = true;
      this.$vs.loading();
      let body = null;
      if(value.body){
        body = JSON.parse(value.body)
      }
      const id = value.id;
      this.$processor.post('/warning-message/seen/' + id).then(() => {
        this.$vs.loading.close();
        this.loadDataNofity +=1;
        this.$eventBus.$emit('loadDataNotify',this.loadDataNofity);
        this.getLists();
      }).catch(() => {
      }).finally(()=>{
        if(body){
          let url = body.url;
          if (url && url.trim().length) {
            // url = url + "?" + this.buildUrlParams(body.params)
            // this.$router.push(url)
          } else {
            setTimeout(()=>{
              this.getLists();
            }, 500)
          }
        }
      });
      if(value){
        this.form = JSON.parse(JSON.stringify(value));
        if(value.details && value.details.fullContents.length > 0){
          this.form.displayFullContent = value.details.fullContents.filter(item => item.type == "text").map((item) => {
            if(item.content){
              return item.content.trim();
            }
          }).join("\n");
        }
        if(value.details && value.details.attachmentUrls.length > 0){
          this.form.domainImage = value.details.attachmentUrls[0].url;
        }
        if(value.title){
          this.form.title = value.title;
        }
        if(value.details && value.details.url){
          this.form.url = value.details.url;
        }
        if(value.details && value.details.attachmentUrls.length  < 1){
          this.form.noImage  =  NoImage;
        }
        this.formDetail=true;
        // this.form.displayPublishDate = moment(this.form.details.publishDate).format("DD/MM/YYYY HH:mm")
        setTimeout(() =>{
          this.$vs.loading.close();
        },500);
      }
    },
    copyLink:function(e){
      let link = e.currentTarget.getAttribute('data-url');
      const textArea = document.createElement('textarea');
      textArea.value = link;
      document.body.appendChild(textArea)
      textArea.select();
      document.execCommand("Copy");
      textArea.style.display = "none";
      this.$vs.notify({
        text: this.$t('warningManager.textCopy'),
        iconPack: 'feather',
        icon: 'icon-alert',
        color: 'primary'
      })
    },

    changeStar: function(){
      this.bookmark = false;
      this.star = true
    },
    changeBookmark: function(){
      this.bookmark = true;
      this.star = false
    },
    warningSetting: function(){
      this.$router.push('/user/warning').catch(() =>{})
    },
    createWarningSetting : function(){
      this.$router.push('/user/warning/add').catch(() =>{})
    },
    warningInfo: function(){
      this.$router.push('/user/warning-info').catch(() =>{})
    },
    followingArticle: function(){
      this.$router.push('/user/article-special').catch(() =>{});
    },
    accountNotification : function (){
      this.$router.push('/user/notify').catch(() =>{});
    },
    itemDeleteAll: function () {
      const payload={};
      this.$processor.post('/warning-message/delete-all', payload).then(() => {
        let url = new URL(location.href);
        let params = new URLSearchParams(url.search);
        params.delete('id');
        this.getListFacebookWarning();
        this.dataRowList=[];
        this.getLists();
        let loadDataNofity = 1;
        this.$eventBus.$emit('loadDataNotify', loadDataNofity);
        this.form = {
          name:null,
          content:null,
          displayFullContent:null,
          domainImage:[],
          title:null,
          noImage:null,
          id:null,
          url:null
        }
        this.selectedContent = false
        this.$vs.notify({
          text:this.$t('warningManager.textDeleteAll'),
          iconPack:'feather',
          icon:'icon-alert',
          colorL:'primary'
        })
      })
        .catch(()=>{
          this.getLists();
          this.$vs.notify({
            text:this.$t('warningManager.textNotDeleteAll'),
            iconPack:'feather',
            icon:'icon-alert',
            color:'danger'
          })
        })
    },
    deleteAll(){
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: this.$t('warningManager.deleteAllWarning'),
        text: this.$t('warningManager.remindDelete'),
        accept: this.itemDeleteAll,
        acceptText:this.$t('button.deleteAll'),
        cancelText: this.$t('button.cancel')
      })
    },
  }
}
</script>
<style scoped>
.warning{
  border-radius: 10px;
  /* padding: 5px 10px 10px 10px; */
  box-shadow: 0px 4px 25px 0px rgba(0, 0, 0, 0.1);
  margin-top: 30px;
}
.border-bottom{
  border-bottom: 1px solid #ccc;
}
/* .cursor-pointer:hover{
  background-color: rgb(221 219 219 / 24%);
} */
.overflow{
  max-width: auto;
  overflow-y: auto;
  overflow-x: auto;
  max-height: 800px;
}
.text{
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 5; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.viewDate{
  position: absolute;
  top:50px;
  right: 2px;
}
/* .content{
  max-width: 51% !important;
  min-width: 50% !important;
} */
.marginLeft{
  width: 5% !important;
}
.cartPost{
  width: 90% !important;
}
.article{
  margin-left: 0px;
  margin-top:10px
}
.copy{
  color: rgba(var(--vs-primary), 1) !important
}
.title-line{
  height: 30px;
  font-size: 12px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2 !important; /* number of lines to show */
  -webkit-box-orient: vertical;
}
.card-height{
  height: 50rem;
  min-height: 12rem;
  overflow-x: hidden !important;
  overflow-y:auto;
}
.card-height::-webkit-scrollbar-track
{
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
  background-color: #F5F5F5;
  border-radius: 5px;
}

.card-height::-webkit-scrollbar
{
  width: 10px;
  background-color: #F5F5F5;
}

.card-height::-webkit-scrollbar-thumb
{
  background-color: #cccccc;
  border: 1px solid #cccccc;
  border-radius: 5px;
}
/* .category{
  width: 15.6667% !important;
  max-height: 300px;
  margin-right: 1%;
} */
/* .warning-notify{
  margin-right: 1%;
  width: 32.3333% !important;
} */
.daterangepicker {
  border-left: none !important;
}
.img-warning{
  object-fit: contain;
  object-position: center bottom;
  max-height: 200px;
}
.actives {
  border-radius: 3px;
  border: 1px solid #277DF6;
  display: inline-block;
  text-align: center;
  padding: 1px 1px 0px 1px;
  height: 28px;
  min-width: 150px;
  margin-right: 10px;
  color: rgb(91, 165, 214)
}
.item-height{
  height: 6.2rem;
}
.con-vs-popup{
  z-index: 50000;
}
.vs-popup{
  height: 694.5px;
  display: inline-table;
}
.includeIcon{
  justify-content: left;
}

</style>
